import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  CardMedia,
  Dialog,
  DialogTitle,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import MobileIcone from "../../images/icon/cell-phone.png";
import OrderIDIcone from "../../images/icon/ID.png";
import PhoneIcone from "../../images/icon/phone-call.png";
import DateIcone from "../../images/icon/timetable.png";
import UserIcone from "../../images/icon/user.png";
import { UseOrders } from "../OrdersPage/UseOrders";
import SubmitButton from "./SubmitButton";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function UserInf(props) {
  const { SetEmoji } = UseOrders();
  const [openInf, setOpenInf] = useState({
    show: false,
    dialogeContent: undefined,
  });
  const [avatarId, setAvatarId] = useState(
    props.orderDetail.emoji.emoji ? props.orderDetail.emoji.emoji : 3
  );
  const [state, setState] = useState({
    firstName: "",
    lastName: "",
  });
  const { isSmall } = useBreakpoints();

  const emojies = [
    { id: 1, icone: "/static/img/Smile.png", title: "عالی" },
    { id: 2, icone: "/static/img/happy.png", title: "خوب" },
    { id: 3, icone: "/static/img/neutral.png", title: "نامشخص" },
    { id: 4, icone: "/static/img/angry.png", title: "بد" },
    { id: 5, icone: "/static/img/devil.png", title: "وحشی" },
  ];

  useEffect(() => {
    if (openInf.show == true) {
      setState({
        firstName: props.orderDetail.firstName,
        lastName: props.orderDetail.lastName,
      });
    }
  }, [openInf]);

  const [stateColor, setStateColor] = useState([
    {
      id: 7,
      name: "همه",
      color: "#bababa",
      borderColor: "#bababa",
    },
    {
      id: 1,
      name: "نامشخص",
      color: "#fff",
      borderColor: "#bababa",
    },
    {
      id: 6,
      name: "حسابرسی",
      color: "#FFC36E",
      borderColor: "#FFC36E",
    },
    {
      id: 4,
      name: "بررسی",
      color: "#ffe7b4",
      borderColor: "#ffe7b4",
    },
    {
      id: 5,
      name: "ارسال",
      color: "#eacdff",
      borderColor: "#eacdff",
    },
    {
      id: 2,
      name: "نهایی",
      color: "#bceda394",
      borderColor: "#bceda394",
    },
    {
      id: 3,
      name: "عدم تایید",
      color: "#ff9393c9",
      borderColor: "#ff9393c9",
    },
    {
      id: 0,
      name: "آنلاین ناموفق",
      color: "#ffdbdb",
      borderColor: "#ffdbdb",
    },
  ]);

  let colorBG = stateColor.find((m) => m.id == props.orderDetail.stateID).color;

  return (
    <Box>
      <Dialog
        fullWidth
        maxWidth="xs"
        onClose={() => {
          setOpenInf({
            show: false,
            dialogeContent: undefined,
          });
          setState({
            firstName: "",
            lastName: "",
          });
          setAvatarId(
            props.orderDetail.emoji.emoji ? props.orderDetail.emoji.emoji : 3
          );
        }}
        open={openInf.show}
      >
        <DialogTitle>ویرایش اطلاعات</DialogTitle>
        {openInf.dialogeContent == "firstName" && (
          <Box
            sx={{
              mx: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <TextField
              fullWidth
              sx={{ mb: 3 }}
              value={state.firstName ? state.firstName : ""}
              label="نام"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  firstName: evt.target.value,
                });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              fullWidth
              value={state.lastName ? state.lastName : ""}
              label="نام خانوادگی"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  lastName: evt.target.value,
                });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <SubmitButton
                fullName
                name1="نام"
                name2="نام خانوادگی"
                Value1={state.firstName}
                Value2={state.lastName}
                FiledName1="firstName"
                FiledName2="lastName"
                id={props.orderDetail.id}
                callback={() => {
                  props.setOrderDetail({
                    ...props.orderDetail,
                    firstName: state.firstName,
                    lastName: state.lastName,
                  });
                  setOpenInf({ ...openInf, show: false });
                }}
              />
              <Button
                sx={{ ml: 1 }}
                color="error"
                variant="outlined"
                onClick={() => setOpenInf({ ...openInf, show: false })}
              >
                انصراف
              </Button>
            </Box>
          </Box>
        )}
        {openInf.dialogeContent == "Avatar" && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mb: 3,
            }}
          >
            <Box sx={{ mb: 2, alignItems: "center", display: "flex", gap: 2 }}>
              {emojies.map((model, i) => {
                return (
                  <Tooltip key={i} title={model.title}>
                    <CardMedia
                      sx={{
                        width:
                          avatarId !== undefined && model.id == avatarId
                            ? "100px"
                            : "55px",
                        mx: "auto",
                        my: 1,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setAvatarId(model.id);
                      }}
                      component="img"
                      alt="green iguana"
                      image={model.icone}
                    />
                  </Tooltip>
                );
              })}
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Button
                onClick={() => {
                  let body = {
                    mobile: props.orderDetail.mobile,
                    EmojiCode: avatarId,
                  };
                  SetEmoji(body, () => {
                    props.setReload(true);
                    setOpenInf({ ...openInf, show: false });
                  });
                }}
                variant="contained"
              >
                ثبت
              </Button>
              <Button
                sx={{ ml: 1 }}
                color="error"
                variant="outlined"
                onClick={() => setOpenInf({ ...openInf, show: false })}
              >
                انصراف
              </Button>
            </Box>
          </Box>
        )}
      </Dialog>
      <Box sx={{ p: 2, mb: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography sx={{ mb: 2 }} color="secondary" variant="h6">
            مشخصات کاربر
          </Typography>
          <CardMedia
            sx={{
              mb: 3,
              width: "60px",
              cursor: "pointer",
            }}
            onClick={() =>
              setOpenInf({
                show: true,
                dialogeContent: "Avatar",
              })
            }
            component="img"
            alt="green iguana"
            image={
              props.orderDetail.emoji
                ? emojies.find((m) => m.id == props.orderDetail.emoji.emoji)
                    .icone
                : emojies[2].icone
            }
          />
        </Box>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={OrderIDIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                شماره سفارش
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 1,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                py: 1,
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.id}
              </Typography>
            </Box>
          </Box>
          <Box
            gridColumn={isSmall ? "span 12" : "span 5"}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={UserIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                نام و نام خانوادگی
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  color: "#3e485c",
                  width: isSmall ? "auto" : "250px",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.firstName + " " + props.orderDetail.lastName}
              </Typography>
              <IconButton
                onClick={() =>
                  setOpenInf({
                    show: true,
                    dialogeContent: "firstName",
                  })
                }
                sx={{ p: 0 }}
              >
                <EditIcon fontSize="small" color="secondary" />
              </IconButton>
            </Box>
          </Box>
          <Box
            gridColumn={isSmall ? "span 12" : "span 4"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={MobileIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                تلفن همراه
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 1,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                py: 1,
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.mobile ? props.orderDetail.mobile : "_"}
              </Typography>
            </Box>
          </Box>
          <Box
            gridColumn={isSmall ? "span 12" : "span 4"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={DateIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                تاریخ سفارش
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 3,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                py: 1,
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#3e485c",
                  direction: "rtl",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.shamsiLogDate
                  ? props.orderDetail.shamsiLogDate
                  : "_"}
              </Typography>
            </Box>
          </Box>
          <Box
            gridColumn={isSmall ? "span 12" : "span 4"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={PhoneIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                تلفن ثابت
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 2,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                py: 1,
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.phone ? props.orderDetail.phone : "-"}
              </Typography>
            </Box>
          </Box>
          <Box
            gridColumn={isSmall ? "span 12" : "span 4"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={PhoneIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                وضعیت سفارش
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 2,
                bgcolor: colorBG ? colorBG : "#f9fafc",
                border: "1px solid #d5dde6",
                py: 1,
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.state ? props.orderDetail.state : "-"}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
